/** The body origin stays at standing centre; changing posture keeps the feet planted. */
export function playerGeometry(standingHeight: number, ducking: boolean) {
  const feet = -standingHeight / 2;
  const height = standingHeight * (ducking ? 0.7 : 1);
  const headRadius = standingHeight * 0.2;
  return {
    feet,
    height,
    top: feet + height,
    centre: feet + height / 2,
    // Keep the head its readable size while compressing the joints beneath it.
    poseScale: (height - headRadius - 0.02) / (standingHeight - headRadius - 0.02),
  };
}
